import { Env } from '../../env';
import { ApiClient } from '../../http/api_client';
import { CouponInformation } from '../../models/coupon/coupon_information';

export class CouponRepository {
  async getCouponInformation(
    couponCodes: string[],
    catalogItemCodes: string[],
    returnItemResponse: string
  ): Promise<CouponInformation> {
    const request = {
      cpnCdList: couponCodes,
      ctgItemCdList: catalogItemCodes,
      returnItemResponse: returnItemResponse
    };

    let result: any;
    try {
      result = await ApiClient.post(
        `${Env.SETTING.userPublicApi.urlBase}odr/apiGetCpnInfo/`,
        request
      );
    } catch (err) {
      result = err.response.data;
    }

    return new CouponInformation(result);
  }
}
